export const INDIVIDUAL_SELECT_ITEM = 'INDIVIDUAL_SELECT_ITEM'
export const INDIVIDUAL_CLEAR = 'INDIVIDUAL_CLEAR'
